module.exports = __webpack_public_path__ + "img/mile5m-m@1.bc5f5921.jpg";